import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CTA from '../Button';
import { CTA_LIST } from '../../constants/CtaList';
import AddressInput from '../AddressInput';
import { EditLocationWrapper, AddressInputWrapper } from './SearchLocationInput.styles';
import { selectDealersList, setToggleEdit } from '../../reducers/dealersListReducer';

const SearchLocationInput: React.FC = () => {
  const dispatch = useDispatch();
  const { centerLocation, isEdit } = useSelector(selectDealersList);

  const handleChange = () => {
    dispatch(setToggleEdit());
  };

  return isEdit ? (
    <EditLocationWrapper>
      <CTA
        buttonText={centerLocation?.name}
        buttonType={CTA_LIST.EDIT_LOCATION}
        onChange={handleChange}
      />
    </EditLocationWrapper>
  ) : (
    <AddressInputWrapper>
      <AddressInput onChange={handleChange} />
    </AddressInputWrapper>
  );
};

export default SearchLocationInput;
